import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import { FuseAnimate, TextFieldFormsy} from '@fuse';
import { DialogContent, CircularProgress, Dialog, Icon, InputAdornment, Card, CardContent, Hidden, Paper, Button, Typography, Divider, DialogActions } from '@material-ui/core';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import Formsy from 'formsy-react';
import classNames from 'classnames';

// import LoginSlider from './LoginSlider';

import green from '@material-ui/core/colors/green';

const styles = theme => ({
    layoutRoot: {},
    success: {
        backgroundColor: green[600],
    },
    root: {
        color : theme.palette.primary.contrastText
    },
    icon : {
        marginBottom: '-6px'
    },
    loadingMasuk: {
        position: 'absolute',
        width: '100%',
        bottom: 0,
        height: 2
    },
    hut: {
        position: 'absolute',
        top: 24,
        right: 24,
        maxWidth: 74
    }
});

class Registrasi extends Component {

    state = {
        error: null,
        isLoaded: false,
        namaPengguna: 'Khalid',
        bottom: false,
        ListMenu: null,
        email: null,
        canSubmit: true,
        loading_besar: false,
        pesan_kesalahan: false,
        routeParams: {
            // peran_id: JSON.parse(localStorage.getItem('user')).peran_id,
            // token: localStorage.getItem('jwt_token')
            media_id: localStorage.getItem('tipe_app')
        },
        disableButton: false,
        pesan_kesalahan_teks: 'error',
        dialog_error: false
    };

    goTolink = (url) => {
        this.props.history.push(url);
        // alert('oke ganti');
    };

    componentDidMount = () => {
        this.props.setJudul("Login Pengguna");
    }

    onSubmit = (model) => {
        this.setState({
            routeParams:{
                ...this.state.routeParams,
                email: model.email,
                kode_registrasi: model.kode_registrasi,
                password: model.password
            },
            loading_besar: true
        },()=>{
            this.props.registrasi(this.state.routeParams).then((result)=>{
                localStorage.setItem('baru_registrasi', '1');

                let callbacks = result.payload;
                // let callbacks = "callbacksync({ 'success' : 0, 'kode' : 3, 'message': 'File prefill tidak ditemukan.' })";
                // console.log( JSON.parse(result.payload.replace('callbacksync(').replace(')')).success );
                // let callBackJson = JSON.parse(callbacks.replace('callbacksync(','').replace(')',''));

                // console.log(callBackJson);
                
                // if( Number( JSON.parse(result.payload.replace('callbacksync(').replace(')')).success ) === 1 ){
                // window.location.href="/";
                // }else{
                //     alert(JSON.parse(result.payload.replace('callbacksync(').replace(')')).message);
                // }
                let callBackJson = JSON.parse(callbacks.replace("callbacksync(","")
                            .replace(")","")
                            .replace("'",'"')
                            .replace("'",'"')
                            .replace("'",'"')
                            .replace("'",'"')
                            .replace("'",'"')
                            .replace("'",'"')
                            .replace("'",'"')
                            .replace("'",'"'))
                ;

                // console.log(callBackJson.success);
                if(Number(callBackJson.success) === 1){
                    window.location.href="/";
                }else{
                    this.setState({
                        dialog_error: true,
                        loading_besar: false,
                        pesan_kesalahan_teks: callBackJson.message
                    });
                }
            });
        });

        // let callbacks = "callbacksync({ 'success' : 0, 'kode' : 3, 'message': 'File prefill tidak ditemukan.' })";
        // console.log( JSON.parse(result.payload.replace('callbacksync(').replace(')')).success );
        // let callBackJson = JSON.parse(callbacks.replace("callbacksync(","")
        //                     .replace(")","")
        //                     .replace("'",'"')
        //                     .replace("'",'"')
        //                     .replace("'",'"')
        //                     .replace("'",'"')
        //                     .replace("'",'"')
        //                     .replace("'",'"')
        //                     .replace("'",'"')
        //                     .replace("'",'"'))
        // ;

        // // console.log(callBackJson.success);
        // if(Number(callBackJson.success) === 1){
        //     window.location.href="/";
        // }else{
        //     this.setState({
        //         dialog_error: true,
        //         pesan_kesalahan_teks: callBackJson.message
        //     });
        // }

    };

    handleChange = (e) => (key) => {
        this.setState({
            routeParams: {
                [key] : e.target.value
            }
        },()=>{
            console.log(this.state);
        })
    }

    render()
    {
        const {classes} = this.props;
        const {canSubmit} = this.state;

        return (
            <div className={classNames(classes.root, "w-full flex flex-col flex-1 p-16 sm:p-0 md:flex-row justify-center konten-utama")} style={{marginBottom:'0px',width:'100%', background:'#287A22'}}>
            {/* <div className={classNames(classes.root, "w-full flex flex-col flex-1 p-16 sm:p-0 md:flex-row justify-center konten-utama")} style={{marginBottom:'0px',width:'100%', backgroundImage:'linear-gradient(to left, #f9d423 0%, #ff4e50 100%)'}}> */}
                <Dialog
                    open={this.state.dialog_error}
                    // open={this.state.loading_besar}
                >
                    <DialogContent id="loading-dialog" style={{textAlign: 'center'}}>
                        <b style={{fontSize:'20px'}}>Proses Registrasi Selesai!</b>
                        <br/>
                        Keterangan: <b>{this.state.pesan_kesalahan_teks}</b>
                        <br/>
                        Silakan cek log registrasi terakhir pada folder Aplikasi EDS Dikdasmen Anda.
                        <br/>
                        Mohon lengkapi data yang diperlukan, kemudian lakukan proses registrasi kembali.
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={()=>this.setState({dialog_error:false})}>Tutup</Button>
                    </DialogActions>
                </Dialog>
                
                <Dialog
                    // open={true}
                    open={this.state.loading_besar}
                >
                    <DialogContent id="loading-dialog" style={{textAlign: 'center'}}>
                        <CircularProgress className={classes.progress} style={{marginLeft:'20px', marginRight:'20px'}}/>
                        <br/>
                        Proses registrasi sedang berlangsung. Mohon tunggu beberapa saat...
                        <br/>
                        Ketika berhasil, Anda akan diarahkan kembali ke halaman login
                    </DialogContent>
                </Dialog>
                <Dialog
                    // open={true}
                    open={this.state.pesan_kesalahan}
                >
                    <DialogContent style={{background:'#ff8a80',color:'black', textAlign: 'center'}} id="error-dialog">
                        Pengguna tidak ditemukan atau password salah. Mohon cek kembali informasi pengguna Anda!
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={()=>{
                                this.setState({
                                    pesan_kesalahan: false
                                })
                            }}
                        >Tutup</Button>
                    </DialogActions>
                </Dialog>
                <Hidden smDown>
                    <div className="relative flex flex-col flex-no-grow items-center justify-center text-white p-16 text-center md:p-128 md:items-start md:flex-no-shrink md:flex-1 md:text-left">
                        {/* <FuseAnimate animation="transition.expandIn"> */}
                        <img className="mb-16" src="/assets/images/logos/logopmp.png" alt="logo" style={{width:'128px', height:'128px'}} />
                        {/* </FuseAnimate> */}
                        <FuseAnimate animation="transition.slideUpIn" delay={300}>
                            <div>
                                <Typography variant="display1" color="inherit" className="font-light font-bold uppercase">
                                    {localStorage.getItem('judul_aplikasi')}
                                </Typography>
                                <Typography variant="display2" color="inherit" className="font-light">
                                    {localStorage.getItem('bos_aplikasi')}
                                </Typography>
                                <Typography variant="body2" color="inherit" className="text-grey-ligther">
                                    {localStorage.getItem('badan_aplikasi')}
                                </Typography>
                                <Typography variant="display1" color="inherit" className="font-light">
                                    <i style={{color:'yellow'}}>versi OFFLINE</i>
                                </Typography>
                            </div>
                        </FuseAnimate>
                    </div>
                </Hidden>
                {/* <FuseAnimate animation={{translateX: [0, '100%']}}> */}
                    <Card style={{maxWidth:'400px', height:'100%'}} className="flex flex-col items-center justify-center w-full mx-auto m-16 md:m-0 rounded-8 sm:rounded-none" square>
                        <CardContent className="w-full p-16 sm:p-32">
                            <Hidden smUp>
                                <div className="flex flex-col flex-no-grow items-center justify-center text-white mb-24 text-center md:p-128 md:items-start md:flex-no-shrink md:flex-1 md:text-left">
                                    <FuseAnimate animation="transition.expandIn">
                                        <img className="w-80 mb-16" src="/assets/images/logos/logopmp.png" alt="logo" />
                                    </FuseAnimate>
                                    <FuseAnimate animation="transition.slideUpIn" delay={300}>
                                        <div>
                                            <Typography variant="h4" color="primary" className="font-bold uppercase text-18">
                                                {localStorage.getItem('judul_aplikasi')}
                                            </Typography>
                                            <Typography variant="h5" color="inherit" className="text-grey-darkest text-14">
                                                {localStorage.getItem('bos_aplikasi')}
                                            </Typography>
                                        </div>
                                    </FuseAnimate>
                                </div>
                            </Hidden>
                            <Typography variant="h6" className="font-bold text-center uppercase md:w-full mb-48 hidden sm:block" color="primary">Registrasi {localStorage.getItem('judul_aplikasi')}</Typography>
                            <div className="w-full">
                                {/* background-image: linear-gradient(to top, #c471f5 0%, #fa71cd 100%) */}
                                <Paper className="p-8" style={{backgroundImage:'linear-gradient(to top, #c471f5 0%, #fa71cd 100%)'}}>
                                    <Typography variant="caption" style={{color:'#ffffff', fontSize:'15px'}}>
                                        Pastikan Anda telah <b>mengunduh file prefill PMP</b> dan menyalinnya pada folder <b>prefill_dapodik</b> sebelum melakukan proses registrasi!
                                    </Typography>
                                </Paper>
                                <br/>
                                <Formsy
                                    onValidSubmit={this.onSubmit}
                                    onValid={this.enableButton}
                                    onInvalid={this.disableButton}
                                    ref={(form) => this.form = form}
                                    className="flex flex-col justify-center w-full"
                                >
                                    <TextFieldFormsy
                                        className="mb-16"
                                        type="text"
                                        name="email"
                                        label="Email"
                                        validations={{
                                            minLength: 4
                                        }}
                                        validationErrors={{
                                            minLength: 'Minimal 4 Karakter'
                                        }}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end"><Icon className="text-20" color="action">email</Icon></InputAdornment>
                                        }}
                                        variant="outlined"
                                        required
                                        // onChange={this.handleChange('email')}
                                    />
                                    <TextFieldFormsy
                                        className="mb-16"
                                        type="password"
                                        name="password"
                                        label="Kata Sandi"
                                        validations={{
                                            minLength: 4
                                        }}
                                        validationErrors={{
                                            minLength: 'Minimal 4 Karakter'
                                        }}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end"><Icon className="text-20" color="action">vpn_key</Icon></InputAdornment>
                                        }}
                                        variant="outlined"
                                        required
                                        // onChange={this.handleChange('password')}
                                    />
                                    <TextFieldFormsy
                                        className="mb-16"
                                        type="text"
                                        name="kode_registrasi"
                                        label="Kode Registrasi"
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end"><Icon className="text-20" color="action">vpn_key</Icon></InputAdornment>
                                        }}
                                        variant="outlined"
                                        required
                                        // onChange={this.handleChange('password')}
                                    />
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        className="w-full mx-auto mt-16 normal-case relative"
                                        aria-label="Masuk"
                                        disabled={!canSubmit}
                                        value="legacy"
                                    >
                                        Registrasi
                                    </Button>
                                    <Divider/>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                        className="w-full mx-auto mt-16 normal-case relative"
                                        aria-label="Masuk"
                                        disabled={!canSubmit}
                                        value="legacy"
                                        onClick={()=>window.location.href="/login"}
                                    >
                                        Kembali ke Login
                                    </Button>
                                </Formsy>
                            </div>
                        </CardContent>
                    </Card>
                {/* </FuseAnimate> */}
                
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getPengguna: Actions.getPengguna,
        tukarPengguna: Actions.tukarPengguna,
        getPeran: Actions.getPeran,
        setFeedback: Actions.setFeedback,
        setLoading: Actions.setLoading,
        setLoadingBesar: Actions.setLoadingBesar,
        setHasilFeedback: Actions.setHasilFeedback,
        setJudul: Actions.setJudul,
        login: Actions.login,
        registrasi: Actions.registrasi,
    }, dispatch);
}

function mapStateToProps({ Pengguna, App }) {

    return {
        pengguna: Pengguna.pengguna,
        hasil_tukar_pengguna: Pengguna.hasil_tukar_pengguna,
        hasil_simpan_feedback: App.hasil_simpan_feedback,
        loading: App.loading,
        peran: Pengguna.peran,
        loading_besar: App.loading_besar,
        hasil_login: App.hasil_login
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Registrasi)));



// WEBPACK FOOTER //
// ./src/main/content/login/Registrasi.js